import React from 'react';
import SimpleThread from '../SimpleThread';
import { COMMENT_MODAL_THREAD_MAX_DEPTH } from '../../constants';
import { ThreadProps } from '../../types';
import s from './ModalThread.scss';

const ModalThread: React.FC<ThreadProps> = props => {
  return (
    <SimpleThread
      {...props}
      scrollableClassName={s['scrollable']}
      commentClassName={s['comment']}
      commentWrapperClassName={s['comment-wrapper']}
      viewRepliesClassName={s['view-replies-wrapper']}
      maxDepthOverride={COMMENT_MODAL_THREAD_MAX_DEPTH}
      replyIndentModifier={1}
    />
  );
};
ModalThread.displayName = 'ModalThread';

export default ModalThread;
